module.exports = __webpack_public_path__ + "static/media/Startseite_Partnerschaften_Multicolumn_Leder_Desktop_Mobile_700x467px_2025-09-01 1.5317be12.jpg";